import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import { useGetTheme } from '../../../../hooks/useGetTheme';
import s from '../column-title.module.scss';
import IconInfo from '../../../iconInfo';

const ColumnEstimatedApr = ({ isMobile }) => {
  const colors = useGetTheme();

  const getTextColor = () => ({ style: { color: colors.text } });

  if (isMobile) {
    return (
      <div className={s.colTitle} {...getTextColor()}>
        Estimated APR
        <Tooltip
          placement='top-start'
          title={
            <div>
              Annual Percentage Reward (APR) refers to the annual percentage rate at which your
              Staking assets earn Rewards on a yearly basis.
            </div>
          }
        >
          <a
            target='_blank'
            rel='noreferrer nofollow noopener'
            href='https://app.mantradao.com/support'
          >
            <IconInfo bg={colors.boringGrey} />
          </a>
        </Tooltip>
      </div>
    );
  }

  return (
    <div>
      <span {...getTextColor()} className={s.title}>
        Estimated <br /> APR
        <Tooltip
          placement='top-end'
          title={
            <div className={s.tooltip}>
              Annual Percentage Reward (APR) refers to the annual percentage rate at which your
              Staking assets earn Rewards on a yearly basis.
            </div>
          }
        >
          <a
            className={s.tooltipIcon}
            target='_blank'
            rel='noreferrer nofollow noopener'
            href='https://app.mantradao.com/support'
          >
            <IconInfo bg={colors.boringGrey} />
          </a>
        </Tooltip>
      </span>
    </div>
  );
};

ColumnEstimatedApr.propTypes = {
  isMobile: PropTypes.bool,
};

ColumnEstimatedApr.defaultProps = {
  isMobile: false,
};

export default ColumnEstimatedApr;
